<template>
  <div class="medical-detail-cntainer">
    <TopBg title="数据资产应用管理系统" sub-title="盘活数据资产，让数据管得住、流得动、用得好" :bg="topBg" />
    <div class="main-content page">
       <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="disc">
          实现数据安全管理、数据共享管理、数据安全运营的能力，提供闭环可持续的医疗数据共享服务，提高医疗服务水平，推动医学研究和创新。
        </div>
      </div>

      <!-- 痛点分析 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-3">
          <PainsAnalysisItem title="获取困难，效率低下" desc="我要做病理研究，该找哪些表?流程怎么走？耗时太久!">
            <template #icon>
              <img src="./assets/pain01.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem title="使用无痕、安全堪忧" desc="每天疲于应付零散取数需求，无法深入做架构和价值挖掘，数据流转安全频出。">
            <template #icon>
              <img src="./assets/pain02.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem title="反馈缺失、价值不清" desc="数据投入巨大，但科研产出和管理效率提升看不见、摸不着，数据价值无法衡量。">
            <template #icon>
              <img src="./assets/pain03.svg" alt="" />
            </template>
          </PainsAnalysisItem>
        </div>
      </div>

      <!-- 解决方案 -->
      <div class="section">
        <div class="title">解决方案</div>
        <div class="card">
          <SolutionItemV2 title="数据集市构建" >
            <template #icon>
              <img src="./assets/solution01.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex mt-16">
            <el-image :src="solutionImg11" :preview-src-list="[solutionImg11]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="数据流通管控" >
            <template #icon>
              <img src="./assets/solution02.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex mt-16">
            <el-image :src="solutionImg21" :preview-src-list="[solutionImg21]" />
          </div>
        </div>

        <div class="card mt-16">
          <SolutionItemV2 title="数据应用管理">
            <template #icon>
              <img src="./assets/solution03.svg" alt="" />
            </template>
          </SolutionItemV2>
          <div class="flex-1 mt-16">
            <el-image :src="solutionImg31" :preview-src-list="[solutionImg31]"/>
          </div>
        </div>
      </div>

        <!-- 核心价值 -->
      <div class="section">
        <div class="title">核心价值</div>
        <div class="rows-3">
          <FeatureItem title="从“人找数据”到“数据找人”，极速赋能科研。">
            <template #icon>
              <img src="./assets/value01.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="从“不敢用”到“放心用”，构建可信流通环境。">    
            <template #icon>
              <img src="./assets/value02.svg" alt="" />
            </template>
          </FeatureItem>
          <FeatureItem title="从“成本中心”到“价值引擎”，让数据价值看得见。">
            <template #icon>
              <img src="./assets/value03.svg" alt="" />
            </template>
          </FeatureItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import SolutionItemV2 from "../../common/solution-item_v2.vue";
import FeatureItem from "../../common/feature-item.vue";
import PainsAnalysisItem from "../../common/pains-analysis-item.vue";

export default {
  name: "DrgPlatform",
  components: {
    TopBg,
    FeatureItem,
    SolutionItemV2,
    PainsAnalysisItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
      solutionImg11: require("./assets/solution11.png"),
      solutionImg21: require("./assets/solution21.png"),
      solutionImg31: require("./assets/solution31.png"),
      mSolutionImg11: require("./assets/m-solution11.png"),
    };
  },
};
</script>
